<template>
  <div class="c-title">
    <div class="c-col-field">{{ description }}</div>
    <div class="c-caption">
      <textarea
        ref="title"
        class="c-caption-input"
        v-model="title"
        :placeholder="`请输入${description}（${min}~${max}个字符,一个中文占两个字符）`"
      ></textarea>
      <span class="c-caption-num">
        <ins :class="warnClass">{{ len }}</ins
        >/{{ max }}
      </span>
    </div>
    <div class="c-words" v-if="words.length > 0">
      <span>动态词插入：</span>
      <a v-for="item in words" :key="item.key" class="c-item-word" @click="setWord(item)">{{ item.value }}</a>
      <div class="c-del-word">
        <a @click="clearWord" class="c-del-a">清除动态词</a>
        <Poptip trigger="hover" placement="top-start" width="410" word-wrap content="要删除动态词请点清除按钮，否则会报错!">
          <Icon type="md-help-circle" size="18" color="#ff4400" />
        </Poptip>
      </div>
    </div>
    <div class="c-col-msg" v-if="msg">
      <span>{{ msg }}</span>
    </div>
  </div>
</template>
<script>
import mixinVerify from './mixin-verify'
import { isArray, getByteLen } from '@/common/js/utils'
export default {
  name: 'cTitle',
  mixins: [mixinVerify],
  props: {
    name: {
      type: String
    },
    description: {
      type: String
    },
    value: {
      type: [Number, String]
    },
    words: {
      type: Array,
      default() {
        return []
      }
    },
    min: {
      type: Number
    },
    max: {
      type: Number
    },
    required: {
      type: Boolean
    },
    pattern: {
      type: String
    },
    verify: {
      type: Boolean
    }
  },
  computed: {
    title: {
      get() {
        return this.value || ''
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    len() {
      let num = 0
      const title = this.title
      if (title) {
        const noWordLen = getByteLen(this.delWord(title))
        num += noWordLen
        // 取出所有动态词
        const words = this.getWords(title)
        if (isArray(words)) {
          const wordLen = words.map((ret) => ret.len[1]).reduce((total, num) => total + num, 0)
          num += wordLen
        }
      }
      return num
    },
    warnClass() {
      return this.len > this.max ? 'm-num-warn' : ''
    }
  },
  methods: {
    setWord(word) {
      const cut = this.$refs.title.selectionStart
      const { key } = word
      if (typeof cut === 'number') {
        const title = this.title
        const prefix = title.substring(0, cut)
        const suffix = title.substring(cut)
        const newTitle = `${prefix}{{${key}}}${suffix}`
        this.$emit('input', newTitle)
      }
    },
    clearWord() {
      const title = this.delWord(this.title)
      this.$emit('input', title)
    },
    delWord(title) {
      return title.replace(/{{[a-z]{2,}}}/g, '')
    },
    getWords(title) {
      if (typeof title !== 'string') return
      // 正则匹配
      const matchWords = title.match(/{{([a-z]){2,}}}/g)
      const keys = this.words.map((ret) => ret.key)
      if (!isArray(matchWords)) return
      return matchWords.map((key) => {
        try {
          return this.getWordKey(key, keys)
        } catch (err) {
          console.log(err)
        }
      })
    },
    getWordKey(key, keys) {
      if (key && isArray(keys)) {
        key = key.replace(/{|}/g, '')
        if (keys.includes(key)) {
          return this.words[this.words.findIndex((ret) => ret.key === key)]
        }
      } else {
        throw new Error('查找动态词位置错误')
      }
    }
  },
  watch: {
    value(nVal) {
      this.$emit('on-change', nVal)
    }
  }
}
</script>
<style lang='scss' scoped>
.c-title {
  width: 100%;
  position: relative;
  z-index: 990;

  .c-col-field {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    position: absolute;
    width: 140px;
    line-height: 32px;
    text-align: right;
    top: 0;
    left: -165px;
  }

  .c-caption {
    border: solid 1px #efefef;

    width: 420px;
    padding: 5px;
    text-align: right;
    border: solid 1px #dcdee2;

    .c-caption-input {
      width: 100%;
      display: block;
      background-color: #fff;
      background-image: none;
      border: 0;
      overflow: hidden;
      resize: none;
      outline: 0;
    }

    .c-caption-num {
      color: #666;
      font-size: 85%;

      .m-num-warn {
        color: #ff4400;
      }
    }
  }

  .c-words {
    padding: 4px 0;

    .c-item-word,
    .c-del-a {
      user-select: none;
    }

    .c-item-word {
      line-height: 25px;
      padding: 0 5px;
      white-space: nowrap;
    }

    .c-del-word {
      display: inline-block;
      margin-left: 20px;

      .c-del-a {
        color: #ff4400;
      }
    }

    .ivu-poptip {
      vertical-align: middle;
      margin-top: -3px;
    }
  }

  .c-col-msg {
    position: absolute;
    z-index: 997;
    left: 0;
    bottom: -16px;
    color: #ff4400;
  }
}
</style>
